'use strict';
module.exports = function ReadOnlyChangesModel ({collaborationModel, goldSessionModel, pageState, s3FileModel}) {
	if (!collaborationModel || !goldSessionModel || !pageState || !s3FileModel) {
		throw new Error('invalid-args');
	}
	const start = async () => {
		const sessionId = collaborationModel.getLocalSessionId();
		if (!sessionId) {
			throw new Error('invalid-args');
		}
		await goldSessionModel.ensureConnection({fileId: pageState.getFileId(), sessionId, clientSecret: s3FileModel.getClientSecret()});
	};
	Object.assign(this, {start});
};
